import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
// Import Sentry
import { configureSentry } from './services/configureSentry';

import Root from './components/Root';

// Initialize Sentry before rendering the app
configureSentry();

// Get environment variables with fallbacks
const clientId = import.meta.env.VITE_APP_COGNITO_CLIENT_ID;
const userPoolId = import.meta.env.VITE_APP_COGNITO_USER_POOL_ID;
const appUrl = import.meta.env.VITE_APP_URL || window.location.origin;

// Cognito OIDC configuration
const cognitoAuthConfig = {
  authority: `https://cognito-idp.eu-central-1.amazonaws.com/${userPoolId}`,
  client_id: clientId,
  redirect_uri: `${appUrl}/admin/`,
  response_type: 'code',
  scope: 'email openid profile',
  post_logout_redirect_uri: `${appUrl}/`,
  extraQueryParams: {
    identity_provider: 'IdentityProviderEntraId',
  },
};

const container = document.getElementById('app')!;
const root = createRoot(container);

root.render(
  <AuthProvider {...cognitoAuthConfig}>
    <Root />,
  </AuthProvider>,
);
